import React, { useState } from 'react';
import { withStyles } from '@mui/styles';
import NumberInput from 'components/inputs/NumberInput';
import useDebounce from 'hooks/useDebounce';

const styles = () => ({
    subtitle: {
        color: '#3A3C43',
        fontSize: 16,
        fontWeight: 700,
        marginTop: 30,
        marginBottom: 14
    },
    numberInput: {
        width: 60
    }
});

const ReapplyComponent = ({ classes, onChange, enabled, initValue = 180, children, hideTitle }) => {
    const [reapplyTimeFrame, setReapplyTimeFrame] = useState(initValue);
    const [reapplyTimeFrameTouched, setReapplyTimeFrameTouched] = useState(false);

    const isValidTimeframe = reapplyTimeFrameTouched && reapplyTimeFrame > 0;
    useDebounce(reapplyTimeFrame, 300, () => {
        if (isValidTimeframe) onChange(reapplyTimeFrame);
    });

    const handleDays = (e) => {
        let inputValue = e.target.value;
        if (inputValue > 9999) {
            inputValue = 9999;
        }
        setReapplyTimeFrameTouched(true);
        setReapplyTimeFrame(+inputValue);
    };

    return (
        <>

            {!hideTitle && (
                <div className={classes.subtitle}>Set Reinvite Timeframe</div>
            )}
            <div className="u-dsp--f u-ai--center u-jc--start u-mrg--tx3">
                <span className="u-mrg--rx2 u-txt--semibold">Allow candidates to take this assessment again</span>
                <NumberInput
                    value={reapplyTimeFrame}
                    onChange={handleDays}
                    type="number"
                    min="1"
                    max={9999}
                    disabled={!enabled}
                    classes={{
			            root: classes.numberInput
			        }}
                />
                <span className="u-mrg--lx2 u-txt--semibold">days after their last attempt</span>
            </div>
            {children}
		</>
    );
};

export default withStyles(styles)(ReapplyComponent);
